/**
 * Volet pleine page admin (section 8.2) : s'ouvre dans la zone de contenu, à droite du menu
 * latéral qui reste visible et cliquable. Barre supérieure (Retour · titre · Annuler/Enregistrer),
 * contenu en cartes sur 2 colonnes (1 colonne sous 900 px via la classe `adm-panel-grid`).
 */
import { Button } from '../../components/ui/kit';
import { AutoSaveStatus } from '../../hooks/useAutoSave';

export function FullPanel({ title, subtitle, onBack, dirty, onCancel, onSave, saveLabel = 'Enregistrer', autoSaveStatus, children, testId }) {
  const auto = autoSaveStatus !== undefined && !onSave;
  return (
    <div className="fixed top-0 bottom-0 right-0 bg-paper overflow-auto animate-slide-in-right z-40" style={{ left: 240 }} data-testid={testId}>
      <div className="sticky top-0 bg-paper/95 backdrop-blur hair-b z-10">
        <div className="flex items-center gap-3 px-6 py-3">
          <button className="vd-link shrink-0" onClick={onBack} data-testid="panel-back">‹ Retour</button>
          <div className="min-w-0 flex-1">
            <h2 className="font-title text-2xl leading-tight truncate">{title}</h2>
            {subtitle && <p className="text-xs text-n600 truncate">{subtitle}</p>}
          </div>
          {auto && <div className="shrink-0 min-w-[110px] text-right" data-testid="panel-autosave"><AutoSaveStatus status={autoSaveStatus} /></div>}
          {!auto && dirty && <span className="text-xs text-n600 whitespace-nowrap hidden sm:inline">Modifications non enregistrées</span>}
          {onSave && (
            <div className="flex items-center gap-2 shrink-0">
              <Button onClick={onCancel} data-testid="panel-cancel">Annuler</Button>
              <Button variant="primary" onClick={onSave} disabled={!dirty} data-testid="panel-save">{saveLabel}</Button>
            </div>
          )}
        </div>
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}

/** Carte de section dans un volet (titre bleu + contenu). */
export function PanelCard({ title, children, className = '', testId }) {
  return (
    <div className={`vd-card p-5 ${className}`} data-testid={testId}>
      {title && <p className="kicker mb-3">{title}</p>}
      {children}
    </div>
  );
}

/** Champ étiqueté générique. */
export function Field({ label, children, hint }) {
  return (
    <label className="block mb-3">
      <span className="block text-[13px] text-n700 mb-1">{label}</span>
      {children}
      {hint && <span className="block text-xs text-n500 mt-1">{hint}</span>}
    </label>
  );
}
